enum AnalyticsEvents {
  // Acquisition
  user_registered = "user_registered",
  user_billing_account_created = "user_billing_account_created",
  user_bootcamp_subscribed = "user_bootcamp_subscribed",
  user_oculus_user_created = "user_oculus_user_created",
  subscription_plan_selected = "subscription_plan_selected",
  payment_initiated = "payment_initiated",
  payment_cancelled = "payment_cancelled",
  payment_success = "payment_success",
  coupon_applied = "coupon_applied",
  remove_from_cart = "remove_from_cart",
  begin_checkout = "begin_checkout",
  b2b_inquiry = "b2b_inquiry",
  payment_exit_reason = "payment_exit_reason",
  verify_email_reported_missing = "verify_email_reported_missing",
  portal_page_view = "portal_page_view",
  no_subscriptions_notification = "no_subscriptions_notification",
  email_verified = "email_verified",

  // Churn
  user_full_access_monthy_cancelled = "user_full_access_monthy_cancelled",
  user_full_access_annual_cancelled = "user_full_access_annual_cancelled",
  user_full_access_monthy_tentative_cancelled = "user_full_access_monthy_tentative_cancelled",
  user_full_access_annual_tentative_cancelled = "user_full_access_annual_tentative_cancelled",
  user_subscription_downgraded = "user_subscription_downgraded",
  user_soft_churn = "user_soft_churn",

  // Conversion
  user_full_access_monthly_subscribed = "user_full_access_monthly_subscribed",
  user_full_access_annual_subscribed = "user_full_access_annual_subscribed",

  // Disengagement
  progression_session_expired = "progression_session_expired",
  practise_session_expired = "practise_session_expired",
  challenge_session_expired = "challenge_session_expired",

  // Engagement - Training sessions
  progression_session_created = "progression_session_created",
  progression_session_completed = "progression_session_completed",
  progression_session_failed = "progression_session_failed",
  practise_session_created = "practise_session_created",
  practise_session_completed = "practise_session_completed",
  practise_session_failed = "practise_session_failed",
  challenge_session_created = "challenge_session_created",
  challenge_session_completed = "challenge_session_completed",
  challenge_session_failed = "challenge_session_failed",

  scenario_retry_clicked = "scenario_retry_clicked",

  // Engagement - Play sessions
  progression_play_session_started = "progression_play_session_started",
  progression_play_session_completed = "progression_play_session_completed",
  progression_play_session_failed = "progression_play_session_failed",
  practise_play_session_started = "practise_play_session_started",
  practise_play_session_completed = "practise_play_session_completed",
  practise_play_session_failed = "practise_play_session_failed",
  challenge_play_session_started = "challenge_play_session_started",
  challenge_play_session_completed = "challenge_play_session_completed",
  challenge_play_session_failed = "challenge_play_session_failed",

  // Engagement - Progression
  user_progression_levelup = "user_progression_levelup",
  user_progression_division_promotion = "user_progression_division_promotion",
  user_progression_league_promotion = "user_progression_league_promotion",
  user_progression_division_demotion = "user_progression_division_demotion",
  user_progression_league_demotion = "user_progression_league_demotion",

  // Generic
  user_login_with_link = "user_login_with_link",
  user_login = "user_login",
  user_logout = "user_logout",
  user_authenicated = "user_authenicated",
  user_unauthenicated = "user_unauthenicated",
  user_password_reset_requested = "user_password_reset_requested",
  user_password_changed = "user_password_changed",
  user_password_reset_confirmed = "user_password_reset_confirmed",
  user_properties_update = "user_properties_update",
  user_is_app_linked = "user_is_app_linked",
  user_link_app_uuid = "user_link_app_uuid",
  access_pin_created = "access_pin_created",

  // Internal
  editor_scenario_created = "scenario_created",
  editor_scenario_updated = "scenario_updated",
  editor_scenario_published = "scenario_published",
  editor_scenario_unpublished = "scenario_unpublished",
  editor_scenario_push_to_production = "editor_scenario_push_to_production",
  editor_scenario_deleted = "scenario_deleted",
  scenario_downloaded = "scenario_downloaded",
  error_occured = "error_occured",

  // Retention
  user_monthly_resubscription = "user_monthly_resubscription",
  user_annual_resubscription = "user_annual_resubscription",

  // Oculus
  user_purchase_byb_plus_1_month_access = "user_purchase_byb_plus_1_month_access",
  user_purchase_byb_plus_3_month_access = "user_purchase_byb_plus_3_month_access",
  user_purchase_byb_plus_6_month_access = "user_purchase_byb_plus_6_month_access",
  user_purchase_byb_plus_12_month_access = "user_purchase_byb_plus_12_month_access",

  //Invites
  user_removed_from_team = "user_removed_from_team",
  invite_sent = "invite_sent",
  invite_accepted = "invite_accepted",
  invite_declined = "invite_declined",

  //Mobile app analytics events
  mobile_app_page_view = "mobile_app_page_view",
  mobile_app_replay_started = "mobile_app_replay_started",
  new_sign_up = "new_sign_up",

  //survey events
  help_improve_survey_answered = "help_improve_survey_answered",
  help_improve_survey_skipped = "help_improve_survey_skipped",

  // In-game Feedback
  feedback_event = "feedback_event",

  // Release notes
  release_note_viewed = "release_note_viewed",

  //cancellation events
  subscription_canceled = "subscription_canceled",
  subscription_keep = "subscription_keep",
  subscription_updated = "subscription_updated",

  //user settings events
  volume_adjusted = "volume_adjusted",
  haptic_strength_adjusted = "haptic_strength_adjusted",
  in_game_feedback_settings_changed = "in_game_feedback_settings_changed",
  selected_language = "selected_language",
  user_avatar_clicked = "user_avatar_clicked",

  //profile events
  leaderboard_status_change = "leaderboard_status_change",
  leaderboard_anonymity_change = "leaderboard_anonymity_change",

  //guides events
  guide_played = "guide_played",

  //challenges events
  join_leaderboard_clicked = "join_leaderboard_clicked",
  see_all_results_clicked = "see_all_results_clicked",
  challenge_started = "challenge_started",
  challenge_see_all_results_clicked = "challenge_see_all_results_clicked",

  //bootcamp events
  challenge_preview_play_clicked = "challenge_preview_play_clicked",
  video_player_play_challenge_clicked = "video_player_play_challenge_clicked",
  skip_bootcamp_clicked = "skip_bootcamp_clicked",
  keep_training_clicked = "keep_training_clicked",

  //practice events
  practice_started = "practice_started",
  practice_settings_adjusted = "practice_settings_adjusted",

  //matchplay events
  matchplay_settings_adjusted = "matchplay_settings_adjusted",
  matchplay_position_updated = "matchplay_position_updated",
  matchplay_started = "matchplay_started",

  //activity events
  results_scenario_clicked = "results_scenario_clicked",
  results_replay_scenario_clicked = "results_replay_scenario_clicked",
  results_overall_clicked = "results_overall_clicked",
  scenario_switched = "scenario_switched",
  replay_2d_started = "replay_2d_started",
  replay_3d_opened = "replay_3d_opened",
  alternative_decision_selected = "alternative_decision_selected",
  decision_score_info_popup_opened = "decision_score_info_popup_opened",
  decision_score_panel_toggled = "decision_score_panel_toggled",
  vision_cone_toggled = "vision_cone_toggled",
  heatmap_toggled = "heatmap_toggled",
  decision_engine_rated = "decision_engine_rated",

  //career events
  career_started = "career_started",

  //positions
  positions_selected = "positions_selected",

  //training plan events
  training_plan_get_started_clicked = "training_plan_get_started_clicked",
  training_plan_not_interested_clicked = "training_plan_not_interested_clicked",
  training_plan_starting_point_selected = "training_plan_starting_point_selected",
  training_plan_frequency_selected = "training_plan_frequency_selected",
  training_plan_enrollment_submitted = "training_plan_enrollment_submitted",
  training_plan_entry_clicked = "training_plan_entry_clicked",
  training_plan_edit_clicked = "training_plan_edit_clicked",
  training_plan_opened = "training_plan_opened",

  // training focus events
  analyze_my_performance_clicked = "analyze_my_performance_clicked",
  how_to_improve_clicked = "how_to_improve_clicked",
  metric_details_clicked = "metric_details_clicked",
  metric_details_video_played = "metric_details_video_played",

  //navigation events
  page_navigated = "page_navigated",

  //BYB360 events
  byb360_folder_created = "byb360_folder_created",
  byb360_clip_saved_to_folder = "byb360_clip_saved_to_folder",
  byb360_shared_folder_created = "byb360_shared_folder_created",
  byb360_clip_saved_to_shared_folder = "byb360_clip_saved_to_shared_folder",

  // Demo Trial
  demo_sign_up = "demo_sign_up",
  demo_account_expired_notification_shown = "demo_account_expired_notification_shown",
  demo_account_expired_notification_go_to_purchase_clicked = "demo_account_expired_notification_go_to_purchase_clicked",
  demo_account_expired_notification_sign_out_clicked = "demo_account_expired_notification_sign_out_clicked",
  demo_account_status_go_to_purchase_clicked = "demo_account_status_go_to_purchase_clicked",
  demo_account_ended = "demo_account_ended",
  demo_account_end_failed = "demo_account_end_failed",
}

export default AnalyticsEvents;
